var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search-light_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.89 15.05l-4.03-4.031a.37.37 0 00-.266-.11h-.322A6.499 6.499 0 006.5 0C2.91.001 0 2.91 0 6.501a6.499 6.499 0 0010.91 4.775v.319c0 .1.04.194.109.265l4.031 4.032a.375.375 0 00.531 0l.31-.31a.375.375 0 000-.531zM6.5 12C3.46 12 1 9.54 1 6.5S3.46 1 6.5 1 12 3.46 12 6.5 9.54 12 6.5 12z",
    fill: "#938BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search-light_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0V0z",
    fill: "#fff"
  })))));
}

export default __webpack_public_path__ + "./fonts/search-light.f6c89198267d1166bd0af13e733531e7.svg";
export { SvgSearchLight as ReactComponent };